const ERROR_MESSAGSES = {
  COURSE_NAME_REQUIRED: 'Course name is required',
};

export default ERROR_MESSAGSES;
